import React from 'react';
import './chart.css';
import { IpaType } from '../../phonemes/ipa';
import { NonPulmonicChart } from './NonPulmonicChart';
import { ConsonantChart } from './ConsonantChart';
import { VowelChart } from './VowelChart';
import { ToneChart } from './ToneChart';

interface ComparisonChartProps {
  /** first set of IPA symbols */
  readonly ipa1: IpaType[];
  /** second set of IPA symbols */
  readonly ipa2: IpaType[];
  /** background color for symbols that only appear in first set */
  readonly only1: string;
  /** background color for symbols that only appear in second set */
  readonly only2: string;

  /** called when a symbol is clicked on */
  readonly clicked?: (ipa: IpaType) => void;
  /** true if a call to 'clicked' will do something useful */
  readonly canClick?: (ipa: IpaType) => boolean;
}

/**
 * show IPA charts comparing what appears in two lists of IPA symbols.
 * it only shows IPA that's in at least one list,
 * changing the background color if it's only in one list
 */
export function ComparisonChart(props: ComparisonChartProps) {
  // display IPA symbol only if it appears in one of the two input sets
  const lookup = (ipa: IpaType): string => {
    const in1 = props.ipa1.includes(ipa);
    const in2 = props.ipa2.includes(ipa);
    return in1 || in2 ? ipa : '-';
  }

  // if symbol only appears in one list, change the background color
  const background = (ipa: IpaType): string | undefined => {
    const in1 = props.ipa1.includes(ipa);
    const in2 = props.ipa2.includes(ipa);
    return in1 && !in2 ? props.only1 : !in1 && in2 ? props.only2 : undefined;
  }

  return (
    <div style={{ display: 'grid' }}>
      <div className='consonants'>
        <div className='tablelabel'>pulmonic consonants</div>
        <ConsonantChart lookup={lookup} background={background} clicked={props.clicked} canClick={props.canClick} />
      </div>
      <div className='cell21'>
        <div className='tablelabel'>nonpulmonic consonants</div>
        <NonPulmonicChart lookup={lookup} background={background} clicked={props.clicked} canClick={props.canClick} />
      </div>
      <div className='cell22'>
        <div className='tablelabel'>vowels</div>
        <VowelChart lookup={lookup} background={background} clicked={props.clicked} canClick={props.canClick} />
      </div>
      <div className='cell23'>
        <div className='tablelabel'>tones</div>
        <ToneChart lookup={lookup} background={background} clicked={props.clicked} canClick={props.canClick} />
      </div>
    </div>
  );
}

